module.exports = __webpack_public_path__ + "media/entities/2305-2a1c012f.png";